import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Actions from "redux/actions";

//components
import AnimatedInput from "../../components/forms/animated_input";
import ButtonBasic from "../../components/common/buttons/button_basic";
import Checkbox from "../../components/forms/checkbox";
import * as Popups from "constants/popup-types";
import Recaptcha from "../../components/services/google/recaptcha";

import Validate from "app/validation/validation";
import Api from "api/requests";

//media
import userIcon from "assets/icons/user.svg";
import passwordIcon from "assets/icons/password.svg";
import azrieli_logo from "assets/icons/azrieli-logo.svg";
import checkedImage from "assets/checkbox/checked-checkbox.svg";
import emptyImage from "assets/checkbox/empty-checkbox.svg";

import "./index.scss";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const deviceState = useSelector((state) => state.deviceState);
  const otpState = useSelector((state) => state.otpData);
  const Gd = useSelector((state) => state.gd);
  const Form = useSelector((state) => state.userForm);
  const isLoggedIn = useSelector((state) => state.logginState);
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const [firstTry, setFirstTry] = useState(true);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [otpCode, setOtpCode] = useState("");
  const [form, setForm] = useState({
    cellphone: {
      valid: false,
      rules: ["cell", "not_empty"],
      errMsg: "",
    },
  });

  const addPopup = (payload) => dispatch(Actions.addPopup(payload));
  const updateForm = (formData) => dispatch(Actions.updateUserForm(formData));
  const setLoader = (state) => dispatch(Actions.setLoader(state));

  useEffect(() => {
    setIsOtpSent(Object.keys(otpState).length !== 0);
  }, [otpState])

  const showAPopup = (msg) => {
    let payload = { text: msg };
    addPopup({ type: Popups.GENERAL_MESSAGE, payload: payload });
  };

  const handleOtp = (e) => {
    // let grecaptcha = window.grecaptcha
    // grecaptcha.ready(() => {
    //     grecaptcha.execute('6Ldo2VMbAAAAAMIhQQEj49fYSWSLcuqSl-D7Fjh8', {action: 'submit'}).then((token) => {
    //         let payload = {};
    //         for (let key in this.state.form) {
    //             payload[key] = this.state.form[key].val
    //         }
    //         this.setState({disable: true});
    //         payload['subject'] = this.state.subject.selected;
    //         payload['sub_subject'] = this.state.sub_subject_selected;
    //         payload['g-recaptcha-response'] = token;
    //         this.props.sendNewLead(payload);
    //     })
    // })
    // e.preventDefault();
    let formValid = true;
    let newState = { ...form };
    let validationObj;
    for (let field in form) {
      validationObj = Validate(Form[field], form[field].rules);

      newState[field].valid = validationObj.valid;
      newState[field].errMsg = validationObj.msg;

      if (!validationObj.valid) {
        formValid = false;
      }
    }

    setForm(newState);
    setFirstTry(false);
    if (formValid) {
      sendLoginOtp();
    }
  };

  const handleResendOtp = (e) => {
    const payload = {
      token: otpState.token,
    };
    setLoader(true);
    Api.resendLoginOtp({ payload: payload }).then((res) => {
      setLoader(false);
    });
  };

  useEffect(() => {
    if (isLoggedIn) {
      navigate("/");
    }
  }, [isLoggedIn]);

  const sendLoginOtp = () => {
    const payload = {
      cellphone: Form.cellphone,
    };
    setLoader(true);
    Api.sendLoginOtp({ payload: payload }).then((res) => {
      setLoader(false);
    });
  };

  const loginUser = () => {
    const payload = {
      token: otpState.token,
      code: otpCode,
    };
    setLoader(true);
    Api.loginUser({ payload: payload }).then((res) => {
      setLoader(false);
      if (res?.status === 1) {
        setIsOtpSent(false);
      }
    });
  };

  const handleInputChange = (e) => {
    const name = e.target.name;
    let val = e.target.value;

    if (e.target.type === "checkbox") {
      val = e.target.checked;
    }

    const validationObj = Validate(val, form[name].rules);

    setForm((prevForm) => ({
      ...prevForm,
      [name]: {
        ...prevForm[name],
        valid: validationObj.valid,
        errMsg: validationObj.msg,
      },
    }));

    updateForm({ [name]: val });
  };
  const showError = (field) => {
    return !firstTry && !form[field].valid;
  };

  return (
    <div className="login-form">
      <div className={"login-header"}>
        <img src={azrieli_logo} className="login-logo" alt="logo" />
        <h1 className="login-title">עזריאלי חניונים</h1>
      </div>
      <form className={"otp-form"} onSubmit={(e) => {e.preventDefault()}}>
        {isOtpSent ? (
            <>
          <span className="otp-title">
            נשלח קוד אימות למספר הטלפון {otpState.cellphone}
          </span>
              <AnimatedInput
                  className="login-otp-input"
                  type="text"
                  inputMode="numeric"
                  value={otpCode}
                  onChange={(e) => setOtpCode(e.target.value)}
                  name="otp-code"
                  placeholder="קוד"
                  autoComplete="off"
              />
              <ButtonBasic className="login-btn" btnText="התחברות" onClick={loginUser} />
              <button className={"send-again-btn"} onClick={handleResendOtp}>לא קיבלתי קוד - שלח שוב</button>
            </>
        ) : (
            <>
              <AnimatedInput
                  className="login-cellphone-input"
                  type="tel"
                  value={Form.cellphone}
                  onChange={handleInputChange}
                  name="cellphone"
                  placeholder="טלפון"
                  errorMessage={Form.cellphone?.errMsg}
                  showError={showError("cellphone")}
                  autoComplete={true}
              />
              <Recaptcha />
              <ButtonBasic className="login-btn" btnText="שלח קוד" onClick={handleOtp} />
            </>
        )}
      </form>
    </div>
  );
};

export default Login;
